import React from 'react';
import {useTranslation} from 'react-i18next';
import * as css from './ETicket.css';
import TicketCardCarousel from './TicketCardCarousel/TicketCardCarousel';
import TicketCard from './TicketCard/TicketCard';
import {useETicketPages} from './hooks/useETicketPages';

function ETicket() {
    const {t} = useTranslation('eTicket');
    const {pages} = useETicketPages();
    const termsLink = {label: t('termsOfUse'), href: 'https://tickchak.co.il/terms'};
   
    return (
        <css.stage data-cy="entrance-ticket-page">
            {['l1', 'l2', 'l3'].map(layer => (
                <css.starLayer key={layer} className={layer} aria-hidden />
            ))}
            <TicketCardCarousel>
                {pages.map(({key, withLink, TopComp, topProps, Comp, props}) => (
                    <TicketCard
                        key={key}
                        top={TopComp ? <TopComp {...(topProps ?? {})} /> : null}
                        footerLink={withLink ? termsLink : undefined}>
                        {Comp ? <Comp {...props} /> : null}
                    </TicketCard>
                ))}
            </TicketCardCarousel>
        </css.stage>
    );
}

export default ETicket;
